/**
 * 分享组件
 * --场景--
 * 斗鱼客户端：使用斗鱼客户端内置分享逻辑
 * 微信等第三方APP：使用分享引导遮罩（微信注册分享配置）
 * 第三方浏览器：使用web分享浮层
 */

// import DYWebShare from './DYWebShare';
// import DYTipShare from './DYTipShare';
import DYWXShare from './DYWXShare';
import DYAppShare from './DYAppShare';
import DYBrowser from '../base';

class DYShare {
    constructor (config) {
        this.config = Object.assign({
            // 分享配置
            shareSetting: {
                // 标题
                title: '',
                // 描述
                desc: '',
                // 链接
                link: '',
                // 图片
                imgUrl: ''
            },
            // 成功回调
            success: null,
            // 取消回调
            cancel: null
        }, config);

        this.timer = null;

        this.init();
    }

    // 初始化
    init () {
        if (DYBrowser.isDyAndroid || DYBrowser.isDyIOS) { // 客户端内
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                this.dyAppShare = new DYAppShare(this.config);
            }, 2000);
        } else if (DYBrowser.isWX) { // 微信
            this.dyWxShare = new DYWXShare(this.config);
        }
    }
}

export default DYShare;
